import { Box } from '@mui/material';
import Lottie from 'lottie-react';
import confettiAnimation from 'src/icons/Confetti.json';

interface ConfettiAnimationProps {
    isPlaying?: boolean;
    loop?: boolean;
    style?: React.CSSProperties;
}

export default function ConfettiAnimation({ isPlaying = true, loop = false, style }: ConfettiAnimationProps) {
    return (
        <Box
            position="fixed"
            top={0}
            left={0}
            width="100%"
            height="100%"
            zIndex={9999}
            sx={{ pointerEvents: 'none' }}
            style={style}
        >
            <Lottie
                animationData={confettiAnimation}
                loop={loop}
                autoplay={isPlaying}
                style={{
                    width: '100%',
                    height: '100%',
                }}
            />
        </Box>
    );
}
